// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { toHashableBallot, toHashableMultiBallot, hashBallot, hashMultiBallot, encryptBallotSelection, encryptMultiBallotSelection, interpretContestSelection, isPreferential, interpretMultiContestSelection, getWriteInAvailableCharacters, decodeAuditableBallot, decodeAuditableMultiBallot, checkIsBlank, signHashableBallot, signHashableMultiBallot, } from "@sequentech/ui-core";
export var provideBallotService = function () { return ({
    toHashableBallot: toHashableBallot,
    toHashableMultiBallot: toHashableMultiBallot,
    hashBallot: hashBallot,
    hashMultiBallot: hashMultiBallot,
    encryptBallotSelection: encryptBallotSelection,
    encryptMultiBallotSelection: encryptMultiBallotSelection,
    interpretContestSelection: interpretContestSelection,
    interpretMultiContestSelection: interpretMultiContestSelection,
    getWriteInAvailableCharacters: getWriteInAvailableCharacters,
    decodeAuditableBallot: decodeAuditableBallot,
    decodeAuditableMultiBallot: decodeAuditableMultiBallot,
    checkIsBlank: checkIsBlank,
    signHashableBallot: signHashableBallot,
    signHashableMultiBallot: signHashableMultiBallot,
    isPreferential: isPreferential,
}); };
